import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './index.css';

const PublicSiteNavigator = () => {
    const navigate = useNavigate();

    const goToPublicSite = () => {
        navigate('/public');
    };

    return (
        <Button className="public-site-button" onClick={goToPublicSite}>
            Public Site
        </Button>
    );
};

export default PublicSiteNavigator;
